import type { ReactNode } from "react";
import { usePlannerSession } from "./planner-session";
import { PlannerContext } from "./planner-context";

/** Shared AI Wedding Planner session for FAB + full-page chat. */
export function PlannerProvider({ children }: { children: ReactNode }) {
  const session = usePlannerSession();
  return <PlannerContext.Provider value={session}>{children}</PlannerContext.Provider>;
}
